import { NgModule } from '@angular/core';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatTreeModule } from '@angular/material/tree';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import {DragDropModule} from '@angular/cdk/drag-drop';

@NgModule({
    declarations: [],
    providers: [
        {
            provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
            useValue: { duration: 4000, verticalPosition: 'top', panelClass: 'sen-snackbar-color' }
        }
    ],
    imports: [
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatGridListModule,
        MatPaginatorModule,
        MatSelectModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatTableModule,
        MatSortModule,
        MatTabsModule,
        MatIconModule,
        MatExpansionModule,
        MatDividerModule,
        MatDialogModule,
        MatChipsModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatProgressSpinnerModule,
        MatListModule,
        MatCardModule,
        MatMenuModule,
        MatRadioModule,
        MatTreeModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatSliderModule,
        DragDropModule
    ],
    exports: [
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatGridListModule,
        MatPaginatorModule,
        MatSelectModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatTableModule,
        MatSortModule,
        MatTabsModule,
        MatIconModule,
        MatExpansionModule,
        MatDividerModule,
        MatDialogModule,
        MatChipsModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatProgressSpinnerModule,
        MatListModule,
        MatCardModule,
        MatMenuModule,
        MatRadioModule,
        MatTreeModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatSliderModule,
        DragDropModule
    ]
})
export class materialModule { }
